// migrated 1:1 from @nexato/nx-core-module, #688
import { Activity } from "../../../entities/activity/activity";
import { ActivityComponent } from "./activityComponent";
import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-files-updated',
  template: `
    <b>{{activity()?.actor?.displayName}}</b> hat {{fileCountText()}} hinzugefügt <app-relative-time [timestamp]="activity()?.createdDateTime" />
    <app-activity-owner-badge
      class='ml-1'
      [owner]="activity()?.owner"
      [ownerId]="ownerId()">
    </app-activity-owner-badge>
  `
})
export class FilesUpdatedActivityComponent implements ActivityComponent {

  readonly activity = input.required<Activity>();
  readonly ownerId = input<string>();

  readonly fileCountText = computed(() => {
    const activity = this.activity();
    const addedFiles = activity?.viewModel?.addedFiles;
    const role = activity?.viewModel?.role;

    if (!addedFiles || addedFiles.length === 0) {
      return '';
    }

    const count = addedFiles.length;
    const isDmgImg = role?.startsWith('dmg');

    if (isDmgImg) {
      return count === 1 ? '1 Bild' : `${count} Bilder`;
    } else {
      return count === 1 ? '1 Anhang' : `${count} Anhänge`;
    }
  });
}
